<template>
  <div class="py-0 px-4 d-flex align-center">
    <mf-icon
      fill
      :size="showProcessingIcon ? 12 : 16"
      :color="isSynchronizing ? '#0079F2' : getStatusLabel(item.status).color"
      :icon="showProcessingIcon ? 'processing' : 'fiber_manual_record'"
      :class="showProcessingIcon ? 'mr-1' : ''"
    />
    {{ isSynchronizing ? 'Sincronizando' : getStatusLabel(item.status).text }}
    <div v-if="synchronizingFailed" class="sync-failed-icon">
      <mf-tooltip top variant="secondary">
        <template #activator="{ on }">
          <mf-icon fill small color="vermelho-0"> warning </mf-icon>
        </template>
        <span>Falha na sincronização com a campanha do e-commerce.</span>
      </mf-tooltip>
    </div>
  </div>
</template>

<script>
import { getStatusLabel } from '@/config/helpers.js'

export default {
  name: 'ExternalSyncStatus',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    syncStatus() {
      return this.item.external_synchronization?.status
    },
    showProcessingIcon() {
      return this.item.status === 'processing' || this.item.status === 'deleting' || this.item.status === 'DELETING' || this.isSynchronizing
    },
    isSynchronizing() {
      return this.syncStatus === 'SYNCHRONIZING' || this.syncStatus === 'synchronizing'
    },
    synchronizingFailed() {
      return this.syncStatus === 'FAILED' || this.syncStatus === 'failed'
    },
  },
  methods: {
    getStatusLabel,
  },
}
</script>

<style lang="scss" scoped>
.sync-failed-icon {
  margin-left: 6px;
  border-radius: 4px;
  background-color: #f47f6833;
  color: $vermelho-d20;
  padding: 2px 4px;
  width: fit-content;
}
</style>
